import { z } from 'zod'
import { oc } from '@orpc/contract'

// Loads the curated PD-1479 (Inna) / PD-1454 (Reham) shared lab panels onto
// EVERY practice organization, the way the other data migrations on the Super
// page seed platform data — no org picker, no id in the path.
//
// It used to seed only the organization the caller was signed in for, resolved
// through `resolveCallerOrg`. That made the migration impossible to run in
// production: a super admin has no org PractitionerRole to resolve from, so the
// call could only ever fail. These panels are curated platform data rather than
// one practice's own order sets, so every practice gets them.
//
// Upsert by panel id, so re-running after editing `order/shared-panels.seed.ts`
// is the supported way to change a code — which is how the two codes still
// awaiting clinical confirmation get swapped.
export const seedSharedPanels = oc
  .route({ method: 'POST', path: '/v2/super/shared-panels/seed' })
  .input(
    z.object({
      /** Seed only this vendor's panels; omit to seed every vendor. */
      vendor: z.string().trim().min(1).optional(),
    }),
  )
  .output(
    z.object({
      /** Panels this run wrote to each organization. */
      seeded: z.number(),
      /** The organizations the panels landed on. */
      organizations: z.array(
        z.object({
          organizationId: z.string(),
          organizationName: z.string(),
          /** Total panels stored on that org after the upsert. */
          panels: z.number(),
          /** True when this run created that org's first shared-panels resource. */
          created: z.boolean(),
        }),
      ),
      /**
       * Organizations the run could not seed, with the reason. Reported rather
       * than thrown so one bad practice cannot hide how far the migration got.
       */
      failures: z.array(
        z.object({
          organizationId: z.string(),
          organizationName: z.string(),
          error: z.string(),
        }),
      ),
    }),
  )
